module.exports = __webpack_public_path__ + "static/img/032 41.8dfd0f3c.jpg";